import { useRequest } from "hooks";
import type { ID, ResourceResponse, ThunkReturnType } from "types";
import useExportTable from "hooks/useExportTable";
import { ApiRouteTypes } from "consts/enpoints/api";
import { changeSetupsExportLoading as changeExportLoading } from "features/setups/slice";
import type { SetupsResponse, Setup, SetupResponse } from "./types";
import {
    getSetupByIdentifierThunk,
    getSetupsThunk,
    updateOrCreateSetupThunk,
    deleteSetupThunk
} from "./thunks";

const useActions = () => {
    const getSetups = useRequest<
        ThunkReturnType<SetupsResponse>,
        string | undefined
    >({
        thunk: getSetupsThunk,
    });

    const getSetupByIdentifier = useRequest<
        ThunkReturnType<SetupResponse<string>>,
        Setup<string>['identifier']
    >({
        thunk: getSetupByIdentifierThunk
    });

    const updateOrCreateSetup = useRequest<
        ThunkReturnType<SetupResponse<string>>,
        Partial<Setup<string>>
    >({
        thunk: updateOrCreateSetupThunk
    });

    const deleteSetup = useRequest<
        ThunkReturnType<ResourceResponse<ID>>,
        Pick<Setup<string>, 'coreId' | 'MOR'>
    >({
        thunk: deleteSetupThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetSetups
    });

    return {
        getSetups,
        getSetupByIdentifier,
        updateOrCreateSetup,
        deleteSetup,
        downloadCsv
    };
};

export default useActions;
